export const seoData = [
  {
    category: "vertical",
    locale: "tr",
    slug: "berber-randevu-programi",
    title: "Berberler İçin Yapay Zeka Destekli Randevu Programı | PLANN",
    metaDescription:
      "Telefon trafiğinden kurtulun, çift randevuyu bitirin. PLANN ile berber randevularını WhatsApp onayı/hatırlatmasıyla otomatikleştirin, no-show’ları azaltın, gelirinizi takip edin.",
    h1: "Berberiniz İçin Daha Az Telefon, Daha Dolu Koltuklar",
    schemaType: "BarberShop",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "barber-appointment-software",
    title: "AI Appointment Software for Barbers | PLANN",
    metaDescription:
      "Stop the phone ringing and end double bookings. PLANN automates barber appointments with WhatsApp confirmations and reminders to cut no-shows, plus simple revenue tracking with subscriptions.",
    h1: "Run Your Barber Shop Without the Constant Phone Calls",
    schemaType: "BarberShop",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "diyetisyen-randevu-programi",
    title: "Diyetisyenler İçin Online Randevu Programı | PLANN",
    metaDescription:
      "Randevu defterindeki karmaşaya son. PLANN ile diyetisyen randevularını tek ekrandan yönetin, WhatsApp hatırlatmalarla iptal/no-show oranını düşürün, gelir-gideri anında görün.",
    h1: "Diyetisyen Randevularınızı Düzenleyin, Danışanlarınızı Kaçırmayın",
    schemaType: "MedicalBusiness",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "dietitian-appointment-software",
    title: "Appointment Software for Dietitians | PLANN",
    metaDescription:
      "Ditch the paper notebook and keep every client on track. PLANN manages dietitian bookings, sends WhatsApp reminders to reduce no-shows, and gives you clear subscription-based revenue tracking.",
    h1: "A Calm, Organised Diary for a Busy Dietitian",
    schemaType: "MedicalBusiness",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "dis-klinigi-randevu-programi",
    title: "Diş Klinikleri İçin Randevu Sistemi | PLANN",
    metaDescription:
      "Telefonlar susmuyor, randevular karışıyor mu? PLANN diş kliniği randevularını otomatik onaylar, WhatsApp hatırlatır, boş saatleri doldurur; gelir ve personeli tek panelde toplar.",
    h1: "Diş Kliniğinizde Randevu Karmaşasını Bitirin",
    schemaType: "Dentist",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "dental-clinic-appointment-software",
    title: "Appointment Software for Dental Clinics | PLANN",
    metaDescription:
      "If the phone never stops and patients ghost appointments, switch to PLANN. Automate confirmations and WhatsApp reminders, prevent double bookings, and track staff and revenue in one place.",
    h1: "Keep Your Dental Diary Full and Your Team in Sync",
    schemaType: "Dentist",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "psikolog-randevu-programi",
    title: "Psikologlar İçin Gizlilik Odaklı Randevu Programı | PLANN",
    metaDescription:
      "Seans saatlerini tek tek aramayla teyit etmekten bıktınız mı? PLANN psikolog randevularını düzenler, WhatsApp hatırlatmalarla no-show’u azaltır, çift randevuyu önler, gelir takibini kolaylaştırır.",
    h1: "Seans Yönetimini Sakinleştirin: Net Takvim, Az No-Show",
    schemaType: "MedicalBusiness",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "psychologist-appointment-software",
    title: "Appointment Software for Psychologists | PLANN",
    metaDescription:
      "Stop chasing confirmations one by one. PLANN keeps your therapy diary organised, sends WhatsApp reminders to reduce no-shows, prevents double bookings, and simplifies revenue tracking.",
    h1: "A Clear Schedule That Protects Your Time and Focus",
    schemaType: "MedicalBusiness",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "fizyoterapi-randevu-programi",
    title: "Fizyoterapistler İçin Randevu Programı | PLANN",
    metaDescription:
      "Seanslar arası koştururken randevu karışmasın. PLANN fizyoterapi randevularını tek ekrana taşır; WhatsApp onay/hatırlatma ile gelmeyenleri azaltır, personel ve gelir takibini netleştirir.",
    h1: "Fizyoterapi Randevularında Düzen: Çift Randevuya Son",
    schemaType: "MedicalBusiness",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "physiotherapy-appointment-software",
    title: "Appointment Software for Physiotherapists | PLANN",
    metaDescription:
      "Keep sessions running smoothly without diary chaos. PLANN manages physio appointments, uses WhatsApp confirmations and reminders to cut no-shows, and gives clear staff and revenue visibility.",
    h1: "More Treatment Time, Less Admin Time",
    schemaType: "MedicalBusiness",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "kuafor-randevu-programi",
    title: "Kuaförler İçin Online Randevu Programı | PLANN",
    metaDescription:
      "Telefon trafiği ve defter karmaşası yüzünden randevular kaybolmasın. PLANN kuaför randevularını kolayca planlar, WhatsApp hatırlatmalarla no-show’u düşürür, gelirinizi ve yoğun saatleri gösterir.",
    h1: "Kuaförünüzü Defterden Kurtarın, Randevuları Otomatikleştirin",
    schemaType: "HairSalon",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "hair-salon-appointment-software",
    title: "Appointment Software for Hair Salons | PLANN",
    metaDescription:
      "No more notebook mess and constant calls. PLANN schedules salon appointments fast, sends WhatsApp reminders to reduce no-shows, prevents double bookings, and helps you track revenue and peak hours.",
    h1: "A Salon Diary That Fills Itself",
    schemaType: "HairSalon",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "guzellik-merkezi-randevu-programi",
    title: "Güzellik Merkezleri İçin Randevu Sistemi | PLANN",
    metaDescription:
      "Müşteri ghosting’i ve çift randevu yüzünden gününüz bozulmasın. PLANN güzellik merkezi randevularını WhatsApp ile otomatik onaylar/hatırlatır, personel planını düzenler, gelir-gideri kontrol altına alır.",
    h1: "Güzellik Merkezinizde No-Show’ları Azaltın, Takvimi Doldurun",
    schemaType: "BeautySalon",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "beauty-salon-appointment-software",
    title: "Appointment Software for Beauty Salons | PLANN",
    metaDescription:
      "Don’t let client ghosting ruin your day. PLANN automates confirmations and WhatsApp reminders, keeps staff schedules tidy, prevents double bookings, and gives clear revenue tracking for your beauty salon.",
    h1: "Reduce No-Shows and Keep Your Beauty Diary Full",
    schemaType: "BeautySalon",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "protez-tirnak-randevu-programi",
    title: "Protez Tırnak Stüdyoları İçin Randevu Programı | PLANN",
    metaDescription:
      "Uzatma/dolgu randevuları karışmasın. PLANN protez tırnak randevularını hızlıca oluşturur, WhatsApp hatırlatmalarla no-show’u azaltır, çift randevuyu önler; gelir takibini tek ekrana taşır.",
    h1: "Protez Tırnak Randevularını Tek Takvimde Toplayın",
    schemaType: "NailSalon",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "nail-studio-appointment-software",
    title: "Appointment Software for Nail Studios | PLANN",
    metaDescription:
      "Keep infill and extension appointments perfectly organised. PLANN creates bookings fast, uses WhatsApp reminders to cut no-shows, prevents double bookings, and makes revenue tracking simple for nail studios.",
    h1: "A Nail Studio Diary That Stays on Time",
    schemaType: "NailSalon",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "spor-salonu-randevu-programi",
    title: "Spor Salonları İçin Ders & Randevu Programı | PLANN",
    metaDescription:
      "Ders saatleri, PT seansları, deneme antrenmanları… Hepsi karışıyor mu? PLANN ile spor salonu randevularını düzenleyin, WhatsApp hatırlatmalarla gelmeyeni azaltın, personel ve gelir takibini netleştirin.",
    h1: "Spor Salonunuzda Randevu ve Ders Düzenini Kurun",
    schemaType: "ExerciseGym",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "gym-booking-software",
    title: "Booking & Appointment Software for Gyms | PLANN",
    metaDescription:
      "PT sessions, trials and classes shouldn’t be chaos. With PLANN you organise gym bookings, send WhatsApp reminders to reduce no-shows, avoid double bookings, and track staff and revenue in one dashboard.",
    h1: "Keep Gym Sessions Booked, Not Back-and-Forth",
    schemaType: "ExerciseGym",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "ozel-ders-randevu-programi",
    title: "Özel Ders Verenler İçin Randevu Programı | PLANN",
    metaDescription:
      "Öğrenciler son dakika iptal mi ediyor? PLANN ile özel ders randevularını kolayca planlayın, WhatsApp hatırlatma/onarım mesajlarıyla gelmeyeni azaltın; gelir ve ders yoğunluğunuzu tek ekranda görün.",
    h1: "Özel Ders Randevularını Düzenleyin, İptalleri Azaltın",
    schemaType: "ProfessionalService",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "private-tutor-booking-software",
    title: "Appointment Software for Private Tutors & Coaches | PLANN",
    metaDescription:
      "Tired of last-minute cancellations? PLANN schedules lessons quickly, sends WhatsApp confirmations and reminders to reduce no-shows, prevents double bookings, and helps you track income from every session.",
    h1: "A Tutor Diary That Keeps Students Showing Up",
    schemaType: "ProfessionalService",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "pilates-studyo-randevu-programi",
    title: "Pilates Stüdyoları İçin Randevu Programı | PLANN",
    metaDescription:
      "Telefon trafiği yüzünden dersler dolmuyor mu? PLANN pilates stüdyosu randevularını düzenler, WhatsApp hatırlatmalarla no-show’u azaltır, eğitmen planlamasını kolaylaştırır; gelir takibini otomatikleştirir.",
    h1: "Pilates Stüdyonuzda Dersleri Doldurun, No-Show’u Düşürün",
    schemaType: "SportsActivityLocation",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "pilates-studio-booking-software",
    title: "Appointment Software for Pilates Studios | PLANN",
    metaDescription:
      "If calls and messages steal your day, switch to PLANN. Organise pilates bookings, send WhatsApp reminders to reduce no-shows, plan instructors easily, and track revenue without a paper notebook.",
    h1: "Fill Classes, Not Your Inbox",
    schemaType: "SportsActivityLocation",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "hali-yikama-randevu-programi",
    title: "Halı Yıkama Firmaları İçin Randevu & Servis Takip Programı | PLANN",
    metaDescription:
      "Adresler karışıyor, telefon hiç susmuyor, teslimat saatleri kaçıyor mu? PLANN; halı yıkama alım-teslim randevularını planlar, WhatsApp ile otomatik bilgilendirir, ekip/personel atar, gelir-gideri anında raporlar.",
    h1: "Halı Yıkamada Alım–Teslim Randevularını Otomatikleştirin",
    schemaType: "HomeAndConstructionBusiness",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "carpet-cleaning-scheduling-software",
    title: "Appointment & Job Scheduling Software for Carpet Cleaning | PLANN",
    metaDescription:
      "When addresses get mixed up and the phone won’t stop, jobs slip. PLANN schedules carpet cleaning pick-up and delivery, sends WhatsApp updates automatically, assigns staff, and tracks every penny of revenue.",
    h1: "Plan Pick-Ups, Deliveries and Teams Without the Chaos",
    schemaType: "HomeAndConstructionBusiness",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "oto-kuafor-randevu-programi",
    title: "Oto Kuaförler İçin Randevu Programı | PLANN",
    metaDescription:
      "Araç yıkama/detay randevularında çift kayıt ve no-show can sıkmasın. PLANN oto kuaför randevularını hızlıca oluşturur, WhatsApp hatırlatmalarla gelmeyeni azaltır; personel ve gelir takibini tek panelde sunar.",
    h1: "Oto Kuaför Randevularında Düzen: Daha Az Boşluk, Daha Çok Ciro",
    schemaType: "AutoWash",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "car-detailing-appointment-software",
    title: "Appointment Software for Car Detailing | PLANN",
    metaDescription:
      "Double bookings and no-shows kill your diary. PLANN schedules car detailing appointments fast, sends WhatsApp reminders to keep customers showing up, and gives you clear staff and revenue tracking in one place.",
    h1: "Keep Your Bays Booked and Your Team Aligned",
    schemaType: "AutoWash",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "oto-ekspertiz-randevu-programi",
    title: "Oto Ekspertiz İçin Randevu Programı | PLANN",
    metaDescription:
      "Muayene saatleri ve müşteri aramaları yüzünden gününüz bölünmesin. PLANN oto ekspertiz randevularını planlar, WhatsApp onay/hatırlatma ile no-show’u azaltır, çift randevuyu önler; geliri kolay takip ettirir.",
    h1: "Oto Ekspertizde Randevuyu Netleştirin, Boş Saatleri Doldurun",
    schemaType: "AutoRepair",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "vehicle-inspection-booking-software",
    title: "Appointment Software for Vehicle Inspection & Auto Expertise | PLANN",
    metaDescription:
      "Don’t let calls interrupt your inspections. PLANN schedules vehicle checks, automates WhatsApp confirmations and reminders to reduce no-shows, prevents double bookings, and helps you track revenue from every job.",
    h1: "A Reliable Inspection Diary With Fewer No-Shows",
    schemaType: "AutoRepair",
  },

  {
    category: "vertical",
    locale: "tr",
    slug: "veteriner-randevu-programi",
    title: "Veterinerler İçin Randevu Programı | PLANN",
    metaDescription:
      "Yoğun klinikte telefon trafiği ve iptaller randevuları bozmasın. PLANN veteriner randevularını düzenler, WhatsApp hatırlatmalarla gelmeyeni azaltır, çift randevuyu önler; gelir takibini sadeleştirir.",
    h1: "Veteriner Kliniğinizde Randevuları Kolayca Yönetin",
    schemaType: "VeterinaryCare",
  },
  {
    category: "vertical",
    locale: "en-GB",
    slug: "vet-appointment-software",
    title: "Appointment Software for Vets & Pet Grooming | PLANN",
    metaDescription:
      "In a busy clinic, calls and cancellations shouldn’t derail your day. PLANN organises vet appointments, sends WhatsApp reminders to reduce no-shows, prevents double bookings, and simplifies revenue tracking.",
    h1: "A Vet Diary That Keeps Pets (and Owners) Turning Up",
    schemaType: "VeterinaryCare",
  },

  {
    category: "feature",
    locale: "tr",
    slug: "yapay-zeka-randevu-asistani",
    title: "Sesle Randevu Oluşturan Yapay Zeka Asistanı | PLANN",
    metaDescription:
      "‘Yarın 14:00’ diye mesaj atın, randevu oluşsun. PLANN Yapay Zeka Randevu Asistanı ile sesli/yazılı komutla randevu ekleyin; telefon trafiğini azaltın, çift randevuyu bitirin.",
    h1: "Randevuları Sesle Yönetin: 10 Saniyede Takvime Ekle",
    schemaType: "SoftwareApplication",
  },
  {
    category: "feature",
    locale: "en-GB",
    slug: "ai-appointment-assistant",
    title: "AI Appointment Assistant (Voice & Text Commands) | PLANN",
    metaDescription:
      "Type or speak it: the booking is created. With PLANN’s AI Appointment Assistant, add appointments by voice/text in seconds, cut admin time, stop the phone ringing, and prevent double bookings.",
    h1: "Create Appointments by Voice Command in Seconds",
    schemaType: "SoftwareApplication",
  },

  {
    category: "feature",
    locale: "tr",
    slug: "whatsapp-randevu-hatirlatma",
    title: "WhatsApp Randevu Hatırlatma Sistemi | No-Show’ları %90 Azaltın | PLANN",
    metaDescription:
      "Müşteriler gelmiyor mu? PLANN WhatsApp hatırlatma ve onay mesajlarıyla no-show/ghosting sorununu %90’a kadar azaltır. Telefonla tek tek aramayın; otomatik bildirimlerle günü doldurun.",
    h1: "WhatsApp Otomatik Hatırlatmalarla No-Show’ları Düşürün",
    schemaType: "SoftwareApplication",
  },
  {
    category: "feature",
    locale: "en-GB",
    slug: "whatsapp-appointment-reminders",
    title: "WhatsApp Appointment Reminders | Cut No‑Shows by Up to 90% | PLANN",
    metaDescription:
      "Customers ghosting appointments? PLANN sends WhatsApp confirmations and reminders automatically to reduce no-shows by up to 90%. Stop chasing people on the phone and keep your diary full.",
    h1: "Automatic WhatsApp Reminders That Keep Customers Showing Up",
    schemaType: "SoftwareApplication",
  },

  {
    category: "feature",
    locale: "tr",
    slug: "online-randevu-sayfasi",
    title: "Online Randevu Sayfası | 7/24 Randevu Alın | PLANN",
    metaDescription:
      "Siz uyurken bile randevu gelsin. PLANN Online Randevu Sayfası ile müşteriler 7/24 boş saatleri görüp randevu alır; telefon trafiği azalır, çift randevu biter, takvim otomatik dolar.",
    h1: "7/24 Online Randevu: Siz Çalışırken de, Uyurken de",
    schemaType: "WebApplication",
  },
  {
    category: "feature",
    locale: "en-GB",
    slug: "online-booking-page",
    title: "Online Booking Page | Get Bookings 24/7 | PLANN",
    metaDescription:
      "Get bookings even while you sleep. With PLANN’s Online Booking Page, customers book available slots 24/7, calls drop, double bookings disappear, and your calendar fills automatically.",
    h1: "24/7 Online Bookings That Fill Your Calendar",
    schemaType: "WebApplication",
  },

  {
    category: "feature",
    locale: "tr",
    slug: "gelir-gider-personel-takibi",
    title: "Gelir-Gider ve Personel Takibi | Defteri Bırakın | PLANN",
    metaDescription:
      "Kağıt defterle hesap yapmayı bırakın. PLANN ile gelir-gideri, abonelik tahsilatını ve personel performansını tek panelde takip edin; randevularla ciroyu eşleştirin, kayıp parayı görün.",
    h1: "Gelir, Gider ve Personel: Her Şeyi Tek Panelde Görün",
    schemaType: "SoftwareApplication",
  },
  {
    category: "feature",
    locale: "en-GB",
    slug: "revenue-expenses-staff-tracking",
    title: "Revenue, Expenses & Staff Tracking | Ditch the Notebook | PLANN",
    metaDescription:
      "Stop doing numbers in a paper notebook. PLANN tracks revenue, expenses, subscriptions and staff performance in one dashboard, so you see exactly where money is made (or lost) with every appointment.",
    h1: "Track Every Penny and Every Team Member, Effortlessly",
    schemaType: "SoftwareApplication",
  },

  {
    category: "feature",
    locale: "tr",
    slug: "mobil-randevu-uygulamasi",
    title: "Mobil Randevu Uygulaması (PWA) | İşiniz Cebinizde | PLANN",
    metaDescription:
      "İşletmenizi cebinizden yönetin. PLANN PWA mobil randevu uygulamasıyla randevu oluşturun, WhatsApp bildirimlerini kontrol edin, gelir takibini görün. Her yerden, her zaman—telefon trafiği olmadan.",
    h1: "PWA Mobil Uygulama ile Her Yerden Randevu Yönetin",
    schemaType: "MobileApplication",
  },
  {
    category: "feature",
    locale: "en-GB",
    slug: "mobile-appointment-app-pwa",
    title: "Mobile Appointment App (PWA) | Run Your Business Anywhere | PLANN",
    metaDescription:
      "Manage your business from your pocket. PLANN’s PWA mobile app lets you create bookings, monitor WhatsApp notifications, and track revenue anywhere—without constant calls, notebook chaos or double bookings.",
    h1: "Your Appointment System in Your Pocket",
    schemaType: "MobileApplication",
  },
];

export const getSeoEntry = ({ category, slug, locale }) =>
  seoData.find(
    (item) =>
      item.category === category && item.slug === slug && item.locale === locale
  );

// ============================================================================
// SEO domain mimarisi: TR = plannapp.co, UK = plannapp.co.uk (self-canonical).
// Canonical URL'ler her zaman locale'in SABİT domaininden üretilir; hangi
// domainden servis edildiğinden bağımsızdır (.com vb. zaten 301 ile kapalı).
// ============================================================================
export const SEO_ORIGINS = {
  tr: "https://plannapp.co",
  "en-GB": "https://plannapp.co.uk",
};

export const CATEGORY_PATHS = {
  vertical: { tr: "cozumler", "en-GB": "solutions" },
  feature: { tr: "ozellikler", "en-GB": "features" },
};

// Gerçek eşdeğer TR ↔ EN sayfa çiftleri (hreflang). Eşdeğeri olmayan sayfa
// bu tabloya EKLENMEZ; sahte hreflang eşleşmesi yasak.
export const HREFLANG_PAIRS = [
  ["berber-randevu-programi", "barber-appointment-software"],
  ["diyetisyen-randevu-programi", "dietitian-appointment-software"],
  ["dis-klinigi-randevu-programi", "dental-clinic-appointment-software"],
  ["psikolog-randevu-programi", "psychologist-appointment-software"],
  ["fizyoterapi-randevu-programi", "physiotherapy-appointment-software"],
  ["kuafor-randevu-programi", "hair-salon-appointment-software"],
  ["guzellik-merkezi-randevu-programi", "beauty-salon-appointment-software"],
  ["protez-tirnak-randevu-programi", "nail-studio-appointment-software"],
  ["spor-salonu-randevu-programi", "gym-booking-software"],
  ["ozel-ders-randevu-programi", "private-tutor-booking-software"],
  ["pilates-studyo-randevu-programi", "pilates-studio-booking-software"],
  ["hali-yikama-randevu-programi", "carpet-cleaning-scheduling-software"],
  ["oto-kuafor-randevu-programi", "car-detailing-appointment-software"],
  ["oto-ekspertiz-randevu-programi", "vehicle-inspection-booking-software"],
  ["veteriner-randevu-programi", "vet-appointment-software"],
  ["yapay-zeka-randevu-asistani", "ai-appointment-assistant"],
  ["whatsapp-randevu-hatirlatma", "whatsapp-appointment-reminders"],
  ["online-randevu-sayfasi", "online-booking-page"],
  ["gelir-gider-personel-takibi", "revenue-expenses-staff-tracking"],
  ["mobil-randevu-uygulamasi", "mobile-appointment-app-pwa"],
];

export const getSeoPath = (entry) =>
  `/${CATEGORY_PATHS[entry.category][entry.locale]}/${entry.slug}`;

export const getSeoUrl = (entry) => `${SEO_ORIGINS[entry.locale]}${getSeoPath(entry)}`;

// Verilen kaydın diğer dildeki eşdeğerini döndürür (yoksa null).
export const getAlternateEntry = (entry) => {
  if (!entry) return null;
  const pair = HREFLANG_PAIRS.find(([tr, en]) =>
    entry.locale === "tr" ? tr === entry.slug : en === entry.slug
  );
  if (!pair) return null;
  const altSlug = entry.locale === "tr" ? pair[1] : pair[0];
  const altLocale = entry.locale === "tr" ? "en-GB" : "tr";
  return seoData.find(
    (item) =>
      item.category === entry.category &&
      item.slug === altSlug &&
      item.locale === altLocale
  );
};

// Ana sayfa meta içerikleri (host bazlı: .co → tr, .co.uk → en-GB)
export const homeSeo = {
  tr: {
    locale: "tr",
    title: "PLANN | Randevu Sistemi ve Online Randevu Uygulaması",
    metaDescription:
      "PLANN ile randevularınızı tek takvimde yönetin, müşterilerinize WhatsApp'tan otomatik onay ve hatırlatma gönderin, online randevu sayfanızla 7/24 randevu alın. Kuaför, berber, güzellik salonu ve tüm hizmet işletmeleri için.",
  },
  "en-GB": {
    locale: "en-GB",
    title: "PLANN | Appointment & Booking Software",
    metaDescription:
      "PLANN is appointment and booking software for salons, barbers, beauty businesses and service professionals. Automate WhatsApp confirmations and reminders, take bookings 24/7 and track revenue in one dashboard.",
  },
};
